export const LOCAL_STORAGE_KEY_INITIAL_LOAD = 'initalLoading'